import { useLazyQuery } from "@apollo/client";
import { onErrorGraphql } from "utils/onErrorGraphql";
import { clientNeoFact } from "@neonumy/api-clients";
import { useEffect, useState } from "react";
import { LIST_RECEIPTS, GET_RECEIPT_URL_PDF } from "queries/neoFact/documents";

export default function useReceiptsApi() {
  const [receiptPdfUrl, setReceiptPdfUrl] = useState<string>("");

  const [listReceipts, { refetch, loading, data: listReceiptsData, error: listReceiptsError }] =
    useLazyQuery<ListReceiptsResponse, ListReceiptsVars>(LIST_RECEIPTS, {
      client: clientNeoFact,
      fetchPolicy: "no-cache",
    });

  useEffect(() => {
    if (listReceiptsError) onErrorGraphql(listReceiptsError);
  }, [listReceiptsError]);

  const dataSource: ListReceiptsResults =
    listReceiptsData?.listReceipts?.results?.map(item => ({
      ...item,
      key: item.id,
    })) ?? [];

  const totalCount = listReceiptsData?.listReceipts?.totalCount ?? 0;

  const [
    getReceiptUrl,
    { loading: loadingPdf, data: getReceiptUrlData, error: getReceiptUrlError },
  ] = useLazyQuery<GetReceiptUrlResponse, GetVarTypeID>(GET_RECEIPT_URL_PDF, {
    client: clientNeoFact,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (getReceiptUrlError) onErrorGraphql(getReceiptUrlError);
  }, [getReceiptUrlError]);

  useEffect(() => {
    if (getReceiptUrlData?.getReceiptUrl) {
      setReceiptPdfUrl(getReceiptUrlData.getReceiptUrl);
    }
  }, [getReceiptUrlData]);

  return {
    refetch,
    loading,
    dataSource,
    totalCount,
    listReceipts,
    getReceiptUrl,
    receiptPdfUrl,
    setReceiptPdfUrl,
    loadingPdf,
  };
}
